import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AuctionListPage from "./pages/auctionListPage";
import LoginPage from "./pages/loginPage";
import ProtectedRoute from "./components/protectedRoute";
import AuctionDataPage from "./pages/auctionDataPage";
import { NotFound } from "./components/notDataFound/noDataFound";
import ImageUploadPage from "./pages/imageUploadPage";
import NbfcLoginPage from "./pages/nbfc/nbfcLogin";
import CreateAuctionPage from "./pages/nbfc/createAuction";
import UploadedAuctionListPage from "./pages/nbfc/uploadedAuctionListPage";
import InventoryListPage from "./pages/nbfc/inventoryList";
import NbfcProtectedRoute from "./components/protectedRoute/nbfcProtectedRoute";
import ViewBidsPage from "./pages/nbfc/viewBidsPage";
import CommonLandingPage from "./components/welcomePage/commonLandingPage";

function App() {
	return (
		<Router>
			<Routes>
				<Route exact path="/login" element={<LoginPage />} />
				<Route exact path="/nbfclogin" element={<NbfcLoginPage />} />
				<Route exact path="/" element={<CommonLandingPage />} />
				<Route element={<NbfcProtectedRoute />}>
					<Route exact path="/create-auction" element={<CreateAuctionPage />} />
				</Route>
				<Route element={<NbfcProtectedRoute />}>
					<Route
						exact
						path="/auctionUploadedList"
						element={<UploadedAuctionListPage />}
					/>
				</Route>
				<Route element={<NbfcProtectedRoute />}>
					<Route
						exact
						path="/uploadedInv/:auctionName/:uplodedId"
						element={<InventoryListPage />}
					/>
				</Route>
				<Route element={<NbfcProtectedRoute />}>
					<Route
						exact
						path="/viewbidstatus/:auctionName/:brand/:model/:uploadedId/:productId"
						element={<ViewBidsPage />}
					/>
				</Route>
				<Route exact path="/imageupload" element={<ImageUploadPage />} />
				<Route element={<ProtectedRoute />}>
					<Route exact path="/auctionListPage" element={<AuctionListPage />} />
				</Route>
				<Route element={<ProtectedRoute />}>
					<Route
						exact
						path="/tractorList/:auctionId"
						element={<AuctionDataPage />}
					/>
				</Route>
				<Route element={<NbfcProtectedRoute />}>
					<Route path="*" element={<NotFound />} />
				</Route>

				<Route element={<ProtectedRoute />}>
					<Route path="*" element={<NotFound />} />
				</Route>

				{/* This route catches unmatched routes */}
				{/* <Route element={<ProtectedRoute />}>
            <Route path="/mfsInv" element={<MfsInvList />} />
      </Route> */}
			</Routes>
		</Router>
	);
}

export default App;
